import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Methodology from "./Methodology";
import EarlyCareerReport from "./EarlyCareerReport";

const EarlyCareerReportRoutes = () => {
    let { path } = useRouteMatch();
    return (
        <div>
            <Route exact path={path} component={EarlyCareerReport} />
            <Route path={`${path}/methodology`} component={Methodology}/>
        </div>
    );
}

export default EarlyCareerReportRoutes;